import styled from "styled-components";
import { motion } from "framer-motion";
import { useState } from "react";
import { Collapse } from "reactstrap";

const Toggle = ({ children, title, show }) => {
  const [toggle, setToggle] = useState(show ? 0 : true);

  return (
    <ToggleContainer>
      <ToggleHeader onClick={() => setToggle(!toggle)}>
        {title} <div className={`close-toggle ${toggle ? "show" : ""}`}></div>
      </ToggleHeader>
      <Collapse className="toggle-content" isOpen={toggle}>
        {children}
      </Collapse>
    </ToggleContainer>
  );
};

const ToggleContainer = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${({ theme }) => theme.inputField};
  box-shadow: ${({ theme }) => theme.shadow};
  border-radius: 10px;
  width: 100%;
  z-index: 100;

  .toggle-content {
    width: 100%;
  }
`;

const ToggleHeader = styled(motion.h4)`
  width: 100%;
  cursor: pointer;
  padding: 0.5rem 1rem;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 7px;
  .close-toggle {
    width: 13px;
    background-color: #009ef7 !important;
    height: 3px;
    z-index: 120;
    position: relative;
    border-radius: 1px;
    transition: 0.2s;
  }

  .close-toggle::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 3px;
    left: 0;
    top: 0;
    background-color: #009ef7;
    border-radius: 1px;
    transition: 0.2s;
  }

  .close-toggle.show::before {
    transform: rotate(90deg);
  }
`;

const ToggleContent = styled(motion.div)`
  width: 100%;
`;

export default Toggle;
